import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InterlinksService {
  constructor() { }

  static getInterlinksModules(): Array<string> {
    return [
      'GroupedInterlinksModule',
      'InterlinksHotelsModules',
      'InterlinksHotelsByPoiModules',
      'InterlinksHotelsByZoneModules',
      'InterlinksHotelsByAmenityModules',
      'InterlinksHotelsByTypeModules',
      'InterlinksHotelsByStarModules'
    ];
  }
}
